import styled from "styled-components";
import { colors } from "../../../styles/colors";

export const StyledExportButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 16px 0 12px;
  border-radius: 100px;
  font-size: 14px;
  font-weight: 500;
  font-family: "Noto Sans Hebrew", sans-serif;
  border: 0.5px solid;
  border-image-source: linear-gradient(
    360deg,
    #34c759 0%,
    rgba(52, 199, 89, 0.1) 100%
  );
  position: relative;
  direction: rtl;
  background: linear-gradient(
    92.35deg,
    rgba(52, 199, 89, 0.2) 4.15%,
    rgba(52, 199, 89, 0.02) 94.8%
  );
  cursor: pointer;
  transition: all 0.2s ease;
  height: 30px;
  color: #34c759;
  box-shadow: 0 2px 4px rgba(52, 199, 89, 0.2);
  margin: 0;
  width: fit-content;

  @media (max-width: 768px) {
    padding: 0 14px;
    height: 30px;
    font-size: 13px;
    min-width: 80px;
  }

  &:focus {
    outline: 2px solid ${colors.green};
    outline-offset: 2px;
  }

  &:focus:not(:focus-visible) {
    outline: none;
  }

  &:hover:not(:disabled) {
    background: linear-gradient(
      92.35deg,
      rgba(52, 199, 89, 0.3) 4.15%,
      rgba(52, 199, 89, 0.05) 94.8%
    );
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(52, 199, 89, 0.3);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(52, 199, 89, 0.2);
  }

  &:disabled {
    background: linear-gradient(
      92.35deg,
      rgba(156, 163, 175, 0.2) 4.15%,
      rgba(156, 163, 175, 0.02) 94.8%
    );
    border-image-source: linear-gradient(
      360deg,
      #9ca3af 0%,
      rgba(156, 163, 175, 0.1) 100%
    );
    cursor: not-allowed;
    opacity: 0.6;
    transform: none;
    box-shadow: none;
  }

  img {
    width: 16px;
    height: 16px;
    object-fit: contain;
  }

  span {
    white-space: nowrap;
  }

  .loading-spinner {
    width: 16px;
    height: 16px;
    border: 2px solid transparent;
    border-top: 2px solid #34c759;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
